import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { TTeesheetNotification } from "redux/reducers/models/teesheet";

export type TTeesheetNotificationType = "admin" | "customer";

export type TTeesheetNotificationTemplate = {
  id: number;
  subject: string;
  content: string;
  user_type: TTeesheetNotificationType;
};

type TGetTeesheetNotificationAll = {
  date?: Date;
  course_id?: string | number;
  user_type?: TTeesheetNotificationType;
};

export type TPostTeesheetNotification = {
  start_date: string;
  end_date: string;
  course_id?: number;
  subject?: string;
  content?: string;
  user_type: TTeesheetNotificationType;
  type?: string; // default = 'passive'
  occurrences?: Array<
    | "everyday"
    | "sunday"
    | "monday"
    | "tuesday"
    | "wednesday"
    | "thursday"
    | "friday"
    | "saturday"
  >;
};

export type TPutTeesheetNotification = {
  id: number;
  start_date?: string;
  end_date?: string;
  course_id?: number;
  subject?: string;
  content?: string;
  user_type: TTeesheetNotificationType;
  type?: string; // default = 'passive'
  update_group?: boolean;
};

export type TPostTeesheetNotificationTemplate = {
  subject: string;
  content: string;
  user_type: TTeesheetNotificationType;
};

export type TPutTeesheetNotificationTemplate = {
  id: number;
  subject: string;
  content: string;
  user_type: TTeesheetNotificationType;
};

//GET
export async function GetTeeSheetNotification(
  params: { id: string | number },
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet<TTeesheetNotification>(
    APIUrl(AdminType.FacilityAdmin, "/tee-sheet/notification"),
    params,
    useGlobalLoader,
    token,
  );
}

export async function GetTeeSheetNotificationAll(
  params: TGetTeesheetNotificationAll,
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet<TTeesheetNotification[]>(
    APIUrl(AdminType.FacilityAdmin, "/tee-sheet/notification/all"),
    params,
    useGlobalLoader,
    token,
  );
}

export async function GetTeeSheetNotificationGroup(
  params: { notification_group_id: string | number },
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet<TTeesheetNotification[]>(
    APIUrl(AdminType.FacilityAdmin, "/tee-sheet/notification/group"),
    params,
    useGlobalLoader,
    token,
  );
}

//POST
export async function PostTeeSheetNotification(params: TPostTeesheetNotification, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/notification"), params, useGlobalLoader);
}

//PUT
export async function PutTeeSheetNotification(params: TPutTeesheetNotification, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/notification"), params, useGlobalLoader);
}

//DELETE
export async function DeleteTeeSheetNotification(
  params: { id: string | number; delete_group?: boolean },
  useGlobalLoader: boolean,
) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/notification"), params, useGlobalLoader);
}

//Notification Templates - GET
export async function GetTeeSheetNotificationTemplate(
  params: { id?: string | number },
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet<TTeesheetNotificationTemplate | TTeesheetNotificationTemplate[]>(
    APIUrl(AdminType.FacilityAdmin, "/tee-sheet/notification/template"),
    params,
    useGlobalLoader,
    token,
  );
}

//Notification Templates - POST
export async function PostTeeSheetNotificationTemplate(
  params: TPostTeesheetNotificationTemplate,
  useGlobalLoader: boolean,
) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/notification/template"), params, useGlobalLoader);
}

//Notification Templates - PUT
export async function PutTeeSheetNotificationTemplate(
  params: TPutTeesheetNotificationTemplate,
  useGlobalLoader: boolean,
) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/notification/template"), params, useGlobalLoader);
}

//Notification Templates - DELETE
export async function DeleteTeeSheetNotificationTemplate(params: { id: string | number }, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/notification/template"), params, useGlobalLoader);
}
